import gql from 'graphql-tag';

export const SpaceMetadataQuery = gql`
	query SpaceMetadataQuery($id: Long!) {
		spaces(spaceId: $id) {
			nodes {
				homepage {
					id
				}
			}
		}
	}
`;
